/* Keep expanded ingredient names in the page flow below an absolute diagram label. */
(function () {
  function init(scope) {
    scope.querySelectorAll('.fdc__diagram').forEach(function (diagram) {
      if (!diagram.querySelector('.fdc__rest') || diagram.dataset.restReady) return;
      diagram.dataset.restReady = 'true';
      function resize() {
        var bottom = diagram.getBoundingClientRect().bottom;
        var overflow = 0;
        diagram.querySelectorAll('.fdc__label').forEach(function (label) {
          overflow = Math.max(overflow, label.getBoundingClientRect().bottom - bottom);
        });
        var extra = diagram.querySelector('.fdc__rest[open]') ? Math.max(0, Math.ceil(overflow) + 16) : 0;
        diagram.style.setProperty('--fdc-rest-space', extra + 'px');
      }
      diagram.querySelectorAll('.fdc__rest').forEach(function (details) {
        details.addEventListener('toggle', resize);
      });
      if (window.ResizeObserver) {
        var observer = new ResizeObserver(resize);
        observer.observe(diagram);
        diagram.querySelectorAll('.fdc__label').forEach(function (label) { observer.observe(label); });
      } else { window.addEventListener('resize', resize); }
      resize();
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
}());
